import { route as searchRoute } from "@faire/web-api/routes/search";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import { useLocation } from "react-router-dom";

import { getSearchPageLoadKey } from "@faire/retailer/nextjs-rsc-util/getSearchPageLoadKey";
import { useSearchPageDataContext } from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/SearchPageDataContext";
import { useSearchPageIsFromDiscoverURL } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageIsFromDiscoverURL";
import { useSearchPageQueryParams } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageQueryParams";
import { shouldShowRscLoggedInSearchPage } from "@faire/retailer/views/search-v2/util/shouldShowRscLoggedInSearchPage";
import { shouldShowRscLoggedOutSearchPage } from "@faire/retailer/views/search-v2/util/shouldShowRscLoggedOutSearchPage";

export const useSearchPageData = () => {
  const {
    productsData,
    isError,
    loading,
    error,
    dataUpdatedAt,
    rscPageLoadKey,
  } = useSearchPageDataContext();
  const { searchQuery, filters, zeroIndexedPageNumber, doQuerySpellCheck } =
    useSearchPageQueryParams();
  const pageLoadKey = getSearchPageLoadKey({
    query: searchQuery,
    filters,
    pageNumber: zeroIndexedPageNumber,
    doQuerySpellCheck,
  });
  const isSearchPage = useIsSearchPage();
  const isDiscoverPage = useSearchPageIsFromDiscoverURL();

  return {
    data: productsData,
    isFetching:
      loading ||
      ((shouldShowRscLoggedOutSearchPage() ||
        shouldShowRscLoggedInSearchPage()) &&
        // Do not show search page loading state on route change from search page to a non-search page route
        (isSearchPage || isDiscoverPage) &&
        // Prevent infinite load on search page in legacy version
        rscPageLoadKey !== "" &&
        rscPageLoadKey !== pageLoadKey),
    isError,
    error,
    dataUpdatedAt,
  };
};

const useIsSearchPage = () => {
  const location = useLocation();
  return pathMatchesRoute(location, searchRoute);
};
